import { Navigate, Route, Routes } from "react-router-dom";
import "./assets/css/backend.css";
import "./assets/css/backend-plugin.min.css";
import "./assets/vendor/remixicon/fonts/remixicon.css";
import "./assets/vendor/line-awesome/dist/line-awesome/css/line-awesome.min.css";
import "./assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";

import DashboardLayout from "./components/layout/DashboardLayout";
import LoginLayout from "./components/Login/LoginLayout";

import { LanguageProvider } from "./hooks/LanguageProvider";
import { ThemeProvider } from "./hooks/ThemeContext";

import { AuthProvider, useAuth } from "./context/AuthContext";
import { UserProvider } from "./context/UserContext";

import { ToastContainer } from "react-toastify";

import Dashboard from "./pages/Dashboard";
import { Users } from "./pages/Users";
import { Suppliers } from "./pages/Suppliers";
import { Settings } from "./pages/Settings";
import User from "./pages/User";
import { GroupeVehicles } from "./pages/GroupVehicule";
import Help from "./pages/Help";
import Vehicle from "./pages/Supplier";
import NewVehicle from "./pages/Vehicle-New";
import Role from "./pages/Role";
import Profile from "./pages/Profile";
import { Permission } from "./pages/Permission";
import UserHistory from "./pages/history-user";
import HistoryVehicle from "./pages/history-vehicle";
import { Chats } from "./pages/Chats";
import { Notifications } from "./pages/Notification";
import Chat from "./pages/Chat";
import NotFound from "./pages/NotFound";
import Connection from "./pages/Connection";
import LoginForm from "./pages/Login";
import { Preferences } from "./pages/Preference";
import NotificationCenter from "./pages/NotificationCenter";
import SignUp from "./pages/SignUp";
import ForgotPasswordCover from "./pages/ForgotPasswordCover";
import Supplier from "./pages/Supplier";
import ProfileSupplier from "./pages/ProfileSupplier";
import SupplierProducts from "./pages/SupplierProducts";
import SupplierMachines from "./pages/SupplierMachines";
import SupplierCertifications from "./pages/SupplierCertifications";
import OEMProfile from "./pages/OEMProfile";
import SupplierDocuments from "./pages/SupplierDocuments";
import SupplierRFQDetails from "./pages/SupplierRFQDetails";
import DemandeOffre from "./pages/DemandeOffre";
import { OEMs } from "./pages/OEMs";
import OEMProfilePage from "./pages/OEMProfile";

function ProtectedRoute({
  children,
  allowedRoles,
}: {
  children: React.ReactNode;
  allowedRoles?: number[];
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div id="loading" style={{ display: "none" }}>
        <div id="loading-center"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.id_role)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

function App() {
  return (
    <AuthProvider>
      <UserProvider>
        <ThemeProvider>
          <LanguageProvider>
            <div
              className="wrapper"
              style={{
                transition: "width 0.3s",
                backgroundColor: "#fff",
                height: "100vh",
                padding: "0px",
              }}
            >
              <Routes>
                <Route
                  path="/"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Dashboard />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/Suppliers"
                  element={
                    <ProtectedRoute allowedRoles={[1]}>
                      <DashboardLayout>
                        <Suppliers />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/Supplier"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Supplier />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/Supplier/add"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Supplier />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/Supplier/edit/:id_vehicule"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Vehicle />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/oem-profile"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <OEMProfile />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />


                <Route
                  path="/OEMs"
                  element={
                    <ProtectedRoute allowedRoles={[1]}>
                      <DashboardLayout>
                        <OEMs />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/oem-profile"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <OEMProfilePage />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/oem-profile/:id_user"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <OEMProfilePage />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

           

                <Route
                  path="/Vehicle-new/edit/:id_vehicule"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <NewVehicle />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/users"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Users />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/User"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <User />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/User/:userurlID"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <User />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/history-vehicle"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <HistoryVehicle />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/history-user"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <UserHistory />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/help"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Help />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/Connection"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Connection />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/Settings"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Settings />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/groupevehicles"
                  element={
                    <ProtectedRoute allowedRoles={[1]}>
                      <DashboardLayout>
                        <GroupeVehicles />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/role"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Role />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/role/permission/:id_user/:id_role"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Permission />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/profile"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Profile />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/profileSupplier"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <ProfileSupplier />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/profileSupplier/:id_user"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <ProfileSupplier />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/chats"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Chats />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/notifications"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Notifications />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/notifications/:id_notification"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Notifications />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/chat"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Chat />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/chat/:id_chat/:id_received"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Chat />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/notification-center/:id_user"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <NotificationCenter />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/preference"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <Preferences />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/SupplierProducts"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <SupplierProducts />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/SupplierMachines"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <SupplierMachines />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/SupplierCertifications"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <SupplierCertifications />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/SupplierDocuments"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <SupplierDocuments />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/supplier-rfq/:id"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <SupplierRFQDetails />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/login"
                  element={
                    <LoginLayout>
                      <LoginForm />
                    </LoginLayout>
                  }
                />

                <Route
                  path="/sign-up"
                  element={
                    <LoginLayout>
                      <SignUp />
                    </LoginLayout>
                  }
                />
                <Route
                  path="/new-rfq"
                  element={
                    <ProtectedRoute>
                      <DashboardLayout>
                        <DemandeOffre />
                      </DashboardLayout>
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="/forgot-password"
                  element={<ForgotPasswordCover />}
                />

                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>

            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={false}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
              theme="light"
              limit={1}
            />
          </LanguageProvider>
        </ThemeProvider>
      </UserProvider>
    </AuthProvider>
  );
}

export default App;
